import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import {tokenHelperFunctions} from "../helper/token.helper";
import { ITeams, ITeamsAllResponse } from "../models/ITeam.model";
import { URLConfig } from "../network/urlStore";

export const getTeams = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ITeamsAllResponse> => {
  let url = URLConfig.getTeamsMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITeamsAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};

export const createTeam = (
  requestPayload: any
): Observable<ITeamsAllResponse> => {
  let url = URLConfig.getTeamsMasterDataURL();
  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as ITeamsAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching crops master data", error);
      }
    );
  });
};

export const getTeamsNextPage = (
  nextPageURI: string
): Observable<ITeamsAllResponse> => {
  let url = URLConfig.getTeamsNextPageURl(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res) => {
        if (res) {
          const response = res as unknown as ITeamsAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching seasons master data", error);
      }
    );
  });
};

export const getContentLengthForTeams = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getTeamsMasterDataURL();

  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const updateTeam = (
  teamsPayload: any,
  teamId: string
): Observable<ITeams> => {
  let url = URLConfig.updateTeamsMasterDataURL(teamId);
  return new Observable((subscriber) => {
    NetworkService.put(url, teamsPayload).then(
      (res) => {
        const response = res as unknown as ITeams;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating field", error);
      }
    );
  });
};

export const patchUpdateTeam = (
  teamsPayload: any,
  teamId: string
): Observable<ITeams> => {
  let url = URLConfig.updateTeamsMasterDataURL(teamId);

  return new Observable((subscriber) => {
    NetworkService.patch(url, teamsPayload).then(
      (res) => {
        const response = res as unknown as ITeams;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating field", error);
      }
    );
  });
};

export const deleteTeam = (teamId: string): Observable<{}> => {
  let url = URLConfig.updateTeamsMasterDataURL(teamId);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (res) => {
        subscriber.next(res);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while deleting team", error);
      }
    );
  });
};

export const getAllTeams = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<ITeams[]> => {
  let allTeams: ITeams[] = [];

  return new Observable((subscriber) => {
    const errorHandler = (error: any) => {
      subscriber.error(error);
      console.log("Error while fetching Teams master data", error);
    };

    const responseHandler = (response: ITeamsAllResponse) => {
      allTeams = [...allTeams, ...(response.teams || [])];

      if (response.nextPageUri) {
        getTeamsNextPage(response.nextPageUri).subscribe({
          next: responseHandler,
          error: errorHandler,
          complete: () => {
            console.info("Completed fetching paginated teams");
          },
        });
      } else {
        subscriber.next(allTeams);
        subscriber.complete();
      }
    };
    getTeams(queryParams).subscribe({
      next: responseHandler,
      error: errorHandler,
      complete: () => {
        console.info("Completed fetching all States");
      },
    });
  });
};


export const getTeamsSpecificUserAccess = (
    email: string,
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<any> => {
  const userAg2AgId = tokenHelperFunctions.fetchAg2AgIdFromToken();

  let url = URLConfig.getTeamsSpecificAccessURL(userAg2AgId);
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as any;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching user teams data", error);
      }
    );
  });
};